import { render, staticRenderFns } from "./InspectionLevelBadge.vue?vue&type=template&id=caab20c6&scoped=true"
import script from "./InspectionLevelBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./InspectionLevelBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./InspectionLevelBadge.vue?vue&type=style&index=0&id=caab20c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caab20c6",
  null
  
)

export default component.exports